// Environment
export const ENV_PRODUCTION = process.env.REACT_APP_NODE_ENV === "production";

// API & Backend URLs
export const API_URL_GRAPHQL = process.env.REACT_APP_API_URL_GRAPHQL; 
export const PRICER_URL = process.env.REACT_APP_PRICER_URL;

// Google Services
export const GOOGLE_API_KEY = process.env.REACT_APP_GOOGLE_API_KEY; 

// Cross-app URLs
export const BORROWER_ONBOARDING_URL = process.env.REACT_APP_BORROWER_ONBOARDING_URL; 
export const BORROWER_DASHBOARD_URL = process.env.REACT_APP_BORROWER_DASHBOARD_URL; 

// Google Analytics
export const GA_MEASUREMENT_ID = process.env.REACT_APP_GA_MEASUREMENT_ID; 

// Analytics & Tracking
export const INSPECTLET_DASHBOARD_PROJECT_ID = process.env.REACT_APP_INSPECTLET_DASHBOARD_PROJECT_ID; 
export const INSPECTLET_ONBOARDING_PROJECT_ID = process.env.REACT_APP_INSPECTLET_ONBOARDING_PROJECT_ID; 
export const HEAP_PROJECT_ID = process.env.REACT_APP_HEAP_PROJECT_ID; // Onboarding usa: VITE_HEAP_PROJECT_ID
export const MIXPANEL_TOKEN = process.env.REACT_APP_MIXPANEL_TOKEN; // Onboarding usa: VITE_MIXPANEL_TOKEN
export const ENABLE_MIXPANEL_LOGS = process.env.REACT_APP_ENABLE_MIXPANEL_LOGS === 'true'; // Onboarding usa: VITE_ENABLE_MIXPANEL_LOGS
export const ENABLE_MIXPANEL_LOGS_PROD = process.env.REACT_APP_ENABLE_MIXPANEL_LOGS_PROD === 'true'; // Onboarding usa: VITE_ENABLE_MIXPANEL_LOGS_PROD

// Onboarding specific URLs (compartidas pero usadas principalmente por Onboarding)
export const PROCESSING_TEAM_URL = process.env.REACT_APP_PROCESSING_TEAM_URL; // Onboarding usa: VITE_PROCESSING_TEAM_URL
export const API_GENERATE_PDF = process.env.REACT_APP_API_GENERATE_PDF; // Onboarding usa: VITE_API_GENERATE_PDF
export const BROKER_MODE_ENABLED = process.env.REACT_APP_BROKER_MODE_ENABLED === 'true'; // Onboarding usa: VITE_BROKER_MODE_ENABLED

// ============================================================================
// DASHBOARD-SPECIFIC ENVIRONMENT VARIABLES
// Variables que solo usa el Dashboard
// ============================================================================
export const INTERCOM_APP_ID = process.env.REACT_APP_INTERCOM_APP_ID;

// Sentry configuration (solo Dashboard)
export const SENTRY_DSN = process.env.REACT_APP_SENTRY_DSN;
export const SENTRY_ENVIRONMENT = process.env.REACT_APP_SENTRY_ENVIRONMENT;
export const SENTRY_SEND_DEFAULT_PII = process.env.REACT_APP_SENTRY_SEND_DEFAULT_PII === 'true';
export const SENTRY_TRACES_SAMPLE_RATE = parseFloat(process.env.REACT_APP_SENTRY_TRACES_SAMPLE_RATE || '1.0');
export const SENTRY_DEBUG = process.env.REACT_APP_SENTRY_DEBUG === 'true';


